import _, { result } from "lodash";
import { log } from "../Helper";
import { format } from 'date-fns';
import { API_ROOT } from "../constants/constants";
import { getAccessToken } from "../utils/okta-config";
import { currencyPayload } from "./utility/constants";

export async function activeQuotesTableData(pageNumber, pageSize, user) {
    try {
        let url =
          `${process.env.REACT_APP_API_ENDPOINT}/forwarderquote/activeQuotesForwarder/` +
          pageNumber +
          `/` +
          pageSize;
    
        const requestOptions = {
          method: "GET",
          headers: {
            userId: user.supplierNumber,
            isInternal: user.internal,
            // userId: "372937",
            // isInternal: false,
            Authorization: `Bearer ${getAccessToken()}`,
            "Access-Control-Allow-Origin": API_ROOT,
          },
        };
        
        const response = await fetch(url, requestOptions);
        // log(response)
        const result = await response.json();
        console.log(result);
        const tableData = result.content.map((quote) => {
          if (result) {
            
            if (_.isEqual(quote.isActive, 1)) {
              quote.isActive = "Open"
            } else {
              quote.isActive = "Close"
            }

            if (!_.isEmpty(quote.expectedTimeframe)) {
              // log("inside date changer");
              const formattedETF = new Date(quote.expectedTimeframe);
              quote.expectedTimeframe = format(formattedETF, 'yyyy-MM-dd');          
              
            } else {
              quote.expectedTimeframe = "";
            }
            quote.comar = quote.orderUnit + quote.orderNumber;
          }
          return quote;
        });
        return tableData;
      } catch (error) {
        console.log(error);
      }

}

export async function saveORupdateQuote(url, requestData){
  const response = await fetch(url, requestData);
  const result = await response.json();
  log('saveORupdateQuote response-- ', result);  
  return result;
}

export async function submittedQuotesTableData(pageNumber, pageSize, user) {
  try {
      let url =
        `${process.env.REACT_APP_API_ENDPOINT}/forwarderquote/submittedQuotesForwarder/` +
        pageNumber +
        `/` +
        pageSize;
  
      const requestOptions = {
        method: "GET",
        headers: {
          userId: user.supplierNumber,
          isInternal: user.internal,
          // userId: "372937",
          // isInternal: false,
          Authorization: `Bearer ${getAccessToken()}`,
          "Access-Control-Allow-Origin": API_ROOT,
        },
      };
      
      const response = await fetch(url, requestOptions);
      // log(response)
      const result = await response.json();
      const tableData = result.content.map((quote) => {
        if (result) {
          
          if (_.isEqual(quote.isActive,1)) {
            quote.status = "Open"
          } else {
            quote.status = "Close"
          }

          if (!_.isEmpty(quote.expectedTimeframe)){
            // log("inside date changer");
            const formattedETF = new Date(quote.expectedTimeframe);
            quote.expectedTimeframe = format(formattedETF,'yyyy-MM-dd');
            
          } else {
            quote.expectedTimeframe = "";
          }
          quote.result = "PENDING"
          quote.comar = quote.orderUnit + quote.orderNumber;
          quote.amount = quote.amount + currencyPayload[quote.currency];
        }
        console.log("QUOTE DATA ", quote)
        if (quote.lowestQuote) {
          quote.amount = (
            <>
              {quote.amount}{" "}
              <span style={{ color: "green", fontSize: "10px", fontWeight: "bold" }}>
                (Best Price)
              </span>
            </>
          );
        } else {
          quote.amount = (
            <>
              {quote.amount}{" "}
            </>
          );
        }
        return quote;
      });
      return tableData;
    } catch (error) {
      console.log(error);
    }

}

export async function quoteResultsDataForwarder(pageNumber, pageSize, user) {
  try {
      let url =
        `${process.env.REACT_APP_API_ENDPOINT}/forwarderquote/quoteResultsForwarder/` +
        pageNumber +
        `/` +
        pageSize;
  
      const requestOptions = {
        method: "GET",
        headers: {
          userId: user.supplierNumber,
          isInternal: user.internal,
          // userId: "372937",
          // isInternal: false,
          Authorization: `Bearer ${getAccessToken()}`,
          "Access-Control-Allow-Origin": API_ROOT,
        },
      };
      
      const response = await fetch(url, requestOptions);
      // log(response)
      const result = await response.json();
      const tableData = result.content.map((quote) => {
        if (result) {
          if (_.isEqual(quote.won,1)) {
            quote.result = "WON";
          } else {
            quote.result = "LOST";
          }

          if (!_.isEmpty(quote.expectedTimeframe)){
            // log("inside date changer");
            const formattedETF = new Date(quote.expectedTimeframe);
            const expectedTimeframe = format(formattedETF,'yyyy-MM-dd') + "(" + "+" + quote.pickupDays + ")";
            quote.expectedTimeframe = expectedTimeframe;          
          } else {
            quote.expectedTimeframe = "";
          }
          quote.comar = quote.orderUnit + quote.orderNumber;
          quote.amount = quote.amount + currencyPayload[quote.currency];
        }
        return quote;
      });
      return tableData;
    } catch (error) {
      console.log(error);
    }

}
